// extracted by mini-css-extract-plugin
export var carrierIcon = "_vl-0";
export var carrierLogo = "_vl-1";
export var detailsSection = "_vl-2";